export class ApplicationLiabilityApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLiabilities({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/liability`);
  }

  async createLiability({ applicationId, withLoanOptionId, ...body }) {
    return this.#http.post(`/application/${applicationId}/liability`, body, {
      params: { withLoanOptionId },
    });
  }

  async editLiability({ applicationId, liabilityId, withLoanOptionId, ...body }) {
    return this.#http.put(`/application/${applicationId}/liability/${liabilityId}`, body, {
      params: { withLoanOptionId },
    });
  }

  async deleteLiability({ applicationId, liabilityId, ...params }) {
    return this.#http.delete(`/application/${applicationId}/liability/${liabilityId}`, { params });
  }

  async updateLiabilities({ applicationId, withLoanOptionId, ...body }) {
    return this.#http.put(`/application/${applicationId}/liabilities`, body, {
      params: { withLoanOptionId },
    });
  }

  async updateAssets({ applicationId, withLoanOptionId, ...body }) {
    return this.#http.put(`/application/${applicationId}/assets`, body, {
      params: { withLoanOptionId },
    });
  }
}
